module.exports = __webpack_public_path__ + "img/tet20201_mobile.d7919777.png";